import * as Yup from 'yup'

export const depositSchema = () =>
  Yup.object().shape({
    bonusAmount: Yup.number()
      .typeError('Only numbers are allowed')
      .min(0, 'Amount should be greater than 0')
      .required('Amount Required')
  })
